var map = {
	"./card1.png": "275d",
	"./card2.png": "a418",
	"./card3.png": "77bd",
	"./check.png": "7e78",
	"./hand.png": "742e",
	"./info.png": "799f",
	"./limit.png": "1779",
	"./limit1cn.png": "7b89",
	"./limit1en.png": "ec89",
	"./limit2cn.png": "343d",
	"./limit2en.png": "d4ed",
	"./logo.png": "ff10",
	"./tag1.png": "5521",
	"./tag2.png": "2db4",
	"./tag3.png": "ccc2",
	"./uncheck.png": "02ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "827f";